import styled from 'styled-components';

export const FullHeightContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;
